import { api } from "assets/scripts/utilities/api-clients";

export const get = async (id) => {
  const response = await api.get(`/kam/rfq/${id}`);

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get("/kam/rfq", options);

  return response;
};

export const post = async (rfq) => {
  const response = await api.post("/kam/rfq", rfq);

  return response;
};

export const put = async (rfq) => {
  const response = await api.put(`/kam/rfq/${rfq._id}`, rfq);

  return response;
};

export const topVendors = async (rfq_id, options) => {
  const response = await api.get(`/kam/rfq/${rfq_id}/top-vendors`, options);

  return response;
};
